const Select = ({ label, value, onChange, options, testid }) => (
  <label className="flex flex-col gap-1 text-[12px]">
    <span className="dl-overline">{label}</span>
    <select
      data-testid={testid}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="bg-white border border-[#E5E7EB] px-3 py-2 text-sm focus:outline-none focus:border-[#111827]"
    >
      {options.map((o) => (
        <option key={o.value} value={o.value}>{o.label}</option>
      ))}
    </select>
  </label>
);

export default Select;
